(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-based-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["core-sas-logo-only-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
    }
  
    connectedCallback() {
      this.waitForHeader(() => {
        this.header = document.getElementById('shopify-section-header');
  
        if (!this.header) {
          console.error('StickyHeader: #shopify-section-header not found.');
          return;
        }
  
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
  
        this.createObserver();
      });
    }
  
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    waitForHeader(callback) {
      const checkHeader = setInterval(() => {
        if (document.getElementById('shopify-section-header')) {
          clearInterval(checkHeader);
          callback();
        }
      }, 100);
    }
  
    createObserver() {
      if (!this.header) return; // Prevent error if header is still missing
  
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries.length > 0) {
          this.headerBounds = entries[0].intersectionRect;
        }
        observer.disconnect();
      });
  
      observer.observe(this.header);
    }
  
    onScroll() {
      if (!this.header) return;
  
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
  
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
  
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    hide() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
  
    reveal() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
  
    reset() {
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  
    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }
  
  customElements.define('sticky-header', StickyHeader);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-emd-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header-nwf"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-lp-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header-with-cta"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-lp-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-lp-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-tv-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-lp-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
   
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-upsell-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
    }
  
    connectedCallback() {
      this.waitForHeader(() => {
        this.header = document.getElementById('shopify-section-header');
  
        if (!this.header) {
          console.error('StickyHeader: #shopify-section-header not found.');
          return;
        }
  
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
  
        this.createObserver();
      });
    }
  
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    waitForHeader(callback) {
      const checkHeader = setInterval(() => {
        if (document.getElementById('shopify-section-header')) {
          clearInterval(checkHeader);
          callback();
        }
      }, 100);
    }
  
    createObserver() {
      if (!this.header) return; // Prevent error if header is still missing
  
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries.length > 0) {
          this.headerBounds = entries[0].intersectionRect;
        }
        observer.disconnect();
      });
  
      observer.observe(this.header);
    }
  
    onScroll() {
      if (!this.header) return;
  
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
  
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
  
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    hide() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
  
    reveal() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
  
    reset() {
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  
    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }
  
  customElements.define('sticky-header', StickyHeader);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preupsell-top-section-new-layout"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('/preupsell-sas-overnight-repair')) {
    const section = document.querySelector('.preupsell-section');
    if (section) {
      section.classList.add('preupsell-overnight');
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('/preupsell-brighten-plus-renew-duo')) {
    const section = document.querySelector('.preupsell-section');
    if (section) {
      section.classList.add('preupsell-brighten-renew-section');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-header-with-cart"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
    }
  
    connectedCallback() {
      this.waitForHeader(() => {
        this.header = document.getElementById('shopify-section-header');
  
        if (!this.header) {
          console.error('StickyHeader: #shopify-section-header not found.');
          return;
        }
  
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
  
        this.createObserver();
      });
    }
  
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    waitForHeader(callback) {
      const checkHeader = setInterval(() => {
        if (document.getElementById('shopify-section-header')) {
          clearInterval(checkHeader);
          callback();
        }
      }, 100);
    }
  
    createObserver() {
      if (!this.header) return; // Prevent error if header is still missing
  
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries.length > 0) {
          this.headerBounds = entries[0].intersectionRect;
        }
        observer.disconnect();
      });
  
      observer.observe(this.header);
    }
  
    onScroll() {
      if (!this.header) return;
  
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
  
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
  
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    hide() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
  
    reveal() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
  
    reset() {
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  
    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }
  
  customElements.define('sticky-header', StickyHeader);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-kit-section"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function() {

   var product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
      $("#free-gift-"+product_id).show();

      $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
        $('.sas-page-kit').removeClass('active selected');
        $(this).parent('.sas-page-kit').siblings().find('.one-time').removeClass('active');
        $(this).parent('.sas-page-kit').addClass("active selected");
        create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"),$(this).attr("id"));
        setTimeout(function(){
          if($('.sas-page-kit.selected.active .subscription.active').length == 0 && $('.sas-page-kit.selected.active .one-time.active').length == 0){
            $('.sas-page-kit.selected.active .subscription .purchase-option-kit').trigger('click');
             var product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
            $(".show-specific-sas-only").hide();
            $("#free-gift-"+product_id).show();
          }
        },200);
      });
          // $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
          //   $('.sas-page-kit').removeClass('active selected');
          //     $(this).parent('.sas-page-kit').addClass("active selected");
          //     create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"))
          //     $('.sas-page-kit').not($(this).parent('.sas-page-kit')).removeClass('active selected');
          //     $(this).find('.radio-button-container').trigger('click');
          // });
          $('.sas-page-kit.active.selected').trigger("click");
          $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event .whatsincluded::after").click(function(e){
            $('.sas-page-kit.active.selected').trigger("click");
          });

          if( screen.width <= 480 ) { $('.accordion-include-section .include-accordion').removeClass( "show" ); }

    });


      function create_sticky_footer(image_src_element,title_element,price_element,button_element,this_id){

     // console.log("The ID of the clicked button is: " + this_id);

        //   $('#'+this_id+" input[type='radio']:first").prop("checked", true);
      //  console.log($('#'+this_id+" input[type='radio']").length);

        $(".prod-img > img").attr("src", image_src_element.attr("src"));
        $(".prod-name > .prod-title").html(title_element.text());
        $(".footer-cart-actions").html(button_element.clone().addClass("sas-kit-footer-cta").attr("href", "javascript:void(0)"));
        $(".sticky-footer-price").html(price_element.html());
      }

     /*$(".sas-purchase-option .one-time").click(function(e){
       console.log('trigger-2-'+$(this).attr("id"));
         $('#'+$(this).attr("id")+" input[type='radio']").prop("checked", true);
   });*/

  // $(document).ready(function() {
  //   $(window).on('load resize scroll', function() {
  //     let scrollTop = $(this).scrollTop();
  //     let $stickyFooter = $(".sticky-sas");
  //         if (!$('.sas-kit-event .sas-kit-cta').isInViewport()) {
  //           create_sticky_footer($(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),$(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),$(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),$(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta"))
  //            $stickyFooter.show();
  //         } else {
  //           $stickyFooter.hide();
  //         }
  //     });
  //   });


  $(document).ready(function() {
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
              let scrollTop = $(window).scrollTop();
              let $stickyFooter = $(".sticky-sas");
                if (scrollTop > 1500 && !$('.sas-kit-event .sas-kit-cta').isInViewport()) {
                    create_sticky_footer(
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta")
                    );
                    $stickyFooter.show();
                } else {
                    $stickyFooter.hide();
                }
                ticking = false;
            });
            ticking = true;
        }
    }
    $(window).on('load resize scroll', onScroll);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-mobile-new-layout-section"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function() {

      let product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
      $("#free-gift-"+product_id).show();

      $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
        $('.sas-page-kit').removeClass('active selected');
        $(this).parent('.sas-page-kit').siblings().find('.one-time').removeClass('active');
        $(this).parent('.sas-page-kit').addClass("active selected");
        $(this).parent('.sas-page-kit').addClass("active selected");
        create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"),$(this).attr("id"));
        setTimeout(function(){
          if($('.sas-page-kit.selected.active .subscription.active').length == 0 && $('.sas-page-kit.selected.active .one-time.active').length == 0){
            $('.sas-page-kit.selected.active .subscription .purchase-option-kit').trigger('click');
            let product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
            $(".show-specific-sas-only").hide();
            $("#free-gift-"+product_id).show();
          }
        },200);
      });
          // $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
          //   $('.sas-page-kit').removeClass('active selected');
          //     $(this).parent('.sas-page-kit').addClass("active selected");
          //     create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"))
          //     $('.sas-page-kit').not($(this).parent('.sas-page-kit')).removeClass('active selected');
          //     $(this).find('.radio-button-container').trigger('click');
          // });
          $('.sas-page-kit.active.selected').trigger("click");
          $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event .whatsincluded::after").click(function(e){
            $('.sas-page-kit.active.selected').trigger("click");
          });

          // if( screen.width <= 640 ) { $('.accordion-include-section .include-accordion').removeClass( "show" ); }

          let lastWidth = window.innerWidth;
          function handleAccordion() {
              if (window.innerWidth <= 640) {
                  $('.accordion-include-section .include-accordion').removeClass('show');
              } else {
                  $('.accordion-include-section .include-accordion').addClass('show');
              }
          }
          // Initial load
          handleAccordion();
          $(window).on('resize orientationchange', function () {

              // Ignore resize events caused by mobile browser scrolling
              if (window.innerWidth === lastWidth) {
                  return;
              }

              lastWidth = window.innerWidth;

              setTimeout(function () {
                  handleAccordion();
              }, 200);
          });
     });


      function create_sticky_footer(image_src_element,title_element,price_element,button_element,this_id){

     // console.log("The ID of the clicked button is: " + this_id);

        //   $('#'+this_id+" input[type='radio']:first").prop("checked", true);
      //  console.log($('#'+this_id+" input[type='radio']").length);

        $(".prod-img > img").attr("src", image_src_element.attr("src"));
        $(".prod-name > .prod-title").html(title_element.text());
        $(".footer-cart-actions").html(button_element.clone().addClass("sas-kit-footer-cta").attr("href", "javascript:void(0)"));
        $(".sticky-footer-price").html(price_element.html());
      }

     /*$(".sas-purchase-option .one-time").click(function(e){
       console.log('trigger-2-'+$(this).attr("id"));
         $('#'+$(this).attr("id")+" input[type='radio']").prop("checked", true);
   });*/

  $(document).ready(function() {
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
              let scrollTop = $(window).scrollTop();
              let $stickyFooter = $(".sticky-sas");
                if (scrollTop > 2450 && !$('.sas-kit-event .sas-kit-cta').isInViewport()) {
                    create_sticky_footer(
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta")
                    );
                    $stickyFooter.show();
                } else {
                    $stickyFooter.hide();
                }
                ticking = false;
            });
            ticking = true;
        }
    }
    $(window).on('load resize scroll', onScroll);


 /* $(".sas-kit-mobile-toggle .sas-kit-toggle-option").on('click', function(){
  let index = $(this).attr('data-kit-index');

  $(".sas-kit-mobile-toggle .sas-kit-toggle-option").removeClass('active');
  $(this).addClass('active');
  $(".sas-kit-mobile-toggle .sas-kit-toggle-radio").prop('checked', false);
  $(this).find('.sas-kit-toggle-radio').prop('checked', true);

  $(".sas-page-kit").removeClass('toggle-active');
  $(".sas-page-kit[data-kit-index='"+index+"']").addClass('toggle-active');

  // Reuse existing selection logic (price, sticky footer, purchase option sync)
  $(".sas-page-kit[data-kit-index='"+index+"'] > .sas-kit-event").trigger('click');
  });

function initMobileToggleKit(){
  if (window.innerWidth <= 640) {
    $(".sas-page-kit").removeClass('toggle-active');
    $(".sas-page-kit[data-kit-index='0']").addClass('toggle-active');
  }
}
initMobileToggleKit();
$(window).on('resize', function(){
  initMobileToggleKit();
});*/

(function () {
  var mq = window.matchMedia('(max-width: 640px)');
  var wasMobile = null;   // tracks breakpoint crossings only

  function activateKit(index) {
    var $kit = $(".sas-page-kit[data-kit-index='" + index + "']");
    if (!$kit.length) return;

    $(".sas-kit-mobile-toggle .sas-kit-toggle-option").removeClass('active');
    $(".sas-kit-mobile-toggle .sas-kit-toggle-radio").prop('checked', false);

    var $opt = $(".sas-kit-mobile-toggle .sas-kit-toggle-option[data-kit-index='" + index + "']");
    $opt.addClass('active');
    $opt.find('.sas-kit-toggle-radio').prop('checked', true);

    $(".sas-page-kit").removeClass('toggle-active');
    $kit.addClass('toggle-active');

    // Reuse existing selection logic (price, sticky footer, purchase option sync)
    $kit.children('.sas-kit-event').trigger('click');
  }

  // click / tap — pointerup covers touch and mouse without the 300ms lag
  $(document).on('click', '.sas-kit-mobile-toggle .sas-kit-toggle-option', function (e) {
    e.preventDefault();
    activateKit($(this).attr('data-kit-index'));
  });

  function initMobileToggleKit() {
    var isMobile = mq.matches;
    if (isMobile === wasMobile) return;   // no breakpoint change -> leave selection alone
    wasMobile = isMobile;

    if (isMobile) {
     var current = $(".sas-kit-mobile-toggle .sas-kit-toggle-option.active").attr("data-kit-index");
      activateKit(current != null ? current : '0');
    } else {
      $(".sas-page-kit").addClass('toggle-active');   // show both on desktop
    }
  }

  $(function () {
    initMobileToggleKit();
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', initMobileToggleKit);
  } else if (mq.addListener) {
    mq.addListener(initMobileToggleKit);   // Safari < 14
  }
  $(window).on('orientationchange', initMobileToggleKit);
})();



});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-tv-kit-section"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function() {

      let product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
      $("#free-gift-"+product_id).show();

      $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
        $('.sas-page-kit').removeClass('active selected');
        $(this).parent('.sas-page-kit').siblings().find('.one-time').removeClass('active');
        $(this).parent('.sas-page-kit').addClass("active selected");
        $(this).parent('.sas-page-kit').addClass("active selected");
        create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"),$(this).attr("id"));
        setTimeout(function(){
          if($('.sas-page-kit.selected.active .subscription.active').length == 0 && $('.sas-page-kit.selected.active .one-time.active').length == 0){
            $('.sas-page-kit.selected.active .subscription .purchase-option-kit').trigger('click');
            let product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
            $(".show-specific-sas-only").hide();
            $("#free-gift-"+product_id).show();
          }
        },200);
      });
          // $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
          //   $('.sas-page-kit').removeClass('active selected');
          //     $(this).parent('.sas-page-kit').addClass("active selected");
          //     create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"))
          //     $('.sas-page-kit').not($(this).parent('.sas-page-kit')).removeClass('active selected');
          //     $(this).find('.radio-button-container').trigger('click');
          // });
          $('.sas-page-kit.active.selected').trigger("click");
          $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event .whatsincluded::after").click(function(e){
            $('.sas-page-kit.active.selected').trigger("click");
          });

          // if( screen.width <= 640 ) { $('.accordion-include-section .include-accordion').removeClass( "show" ); }

          let lastWidth = window.innerWidth;
          function handleAccordion() {
              if (window.innerWidth <= 640) {
                  $('.accordion-include-section .include-accordion').removeClass('show');
              } else {
                  $('.accordion-include-section .include-accordion').addClass('show');
              }
          }
          // Initial load
          handleAccordion();
          $(window).on('resize orientationchange', function () {

              // Ignore resize events caused by mobile browser scrolling
              if (window.innerWidth === lastWidth) {
                  return;
              }

              lastWidth = window.innerWidth;

              setTimeout(function () {
                  handleAccordion();
              }, 200);
          });
     });


      function create_sticky_footer(image_src_element,title_element,price_element,button_element,this_id){

     // console.log("The ID of the clicked button is: " + this_id);

        //   $('#'+this_id+" input[type='radio']:first").prop("checked", true);
      //  console.log($('#'+this_id+" input[type='radio']").length);

        $(".prod-img > img").attr("src", image_src_element.attr("src"));
        $(".prod-name > .prod-title").html(title_element.text());
        $(".footer-cart-actions").html(button_element.clone().addClass("sas-kit-footer-cta").attr("href", "javascript:void(0)"));
        $(".sticky-footer-price").html(price_element.html());
      }

     /*$(".sas-purchase-option .one-time").click(function(e){
       console.log('trigger-2-'+$(this).attr("id"));
         $('#'+$(this).attr("id")+" input[type='radio']").prop("checked", true);
   });*/

  $(document).ready(function() {
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
              let scrollTop = $(window).scrollTop();
              let $stickyFooter = $(".sticky-sas");
                if (scrollTop > 2450 && !$('.sas-kit-event .sas-kit-cta').isInViewport()) {
                    create_sticky_footer(
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta")
                    );
                    $stickyFooter.show();
                } else {
                    $stickyFooter.hide();
                }
                ticking = false;
            });
            ticking = true;
        }
    }
    $(window).on('load resize scroll', onScroll);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-sas-kit-section"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function() {

      let product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
      $("#free-gift-"+product_id).show();

      $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
        $('.sas-page-kit').removeClass('active selected');
        $(this).parent('.sas-page-kit').siblings().find('.one-time').removeClass('active');
        $(this).parent('.sas-page-kit').addClass("active selected");
        $(this).parent('.sas-page-kit').addClass("active selected");
        create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"),$(this).attr("id"));
        setTimeout(function(){
          if($('.sas-page-kit.selected.active .subscription.active').length == 0 && $('.sas-page-kit.selected.active .one-time.active').length == 0){
            $('.sas-page-kit.selected.active .subscription .purchase-option-kit').trigger('click');
            let product_id = $('.sas-page-kit.selected.active').attr("data-sas_product_kit");
            $(".show-specific-sas-only").hide();
            $("#free-gift-"+product_id).show();
          }
        },200);
      });
          // $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event").click(function(e){
          //   $('.sas-page-kit').removeClass('active selected');
          //     $(this).parent('.sas-page-kit').addClass("active selected");
          //     create_sticky_footer($(this).find(".sas-kit-image > img"),$(this).find(".sas-kit-title"),$(this).find(".sas-kit-price"),$(this).find(".sas-kit-cta"))
          //     $('.sas-page-kit').not($(this).parent('.sas-page-kit')).removeClass('active selected');
          //     $(this).find('.radio-button-container').trigger('click');
          // });
          $('.sas-page-kit.active.selected').trigger("click");
          $(".sas-page-kits-wrapper .sas-page-kit .sas-kit-event .whatsincluded::after").click(function(e){
            $('.sas-page-kit.active.selected').trigger("click");
          });

          if( screen.width <= 480 ) { $('.accordion-include-section .include-accordion').removeClass( "show" ); }

    });


      function create_sticky_footer(image_src_element,title_element,price_element,button_element,this_id){

     // console.log("The ID of the clicked button is: " + this_id);

        //   $('#'+this_id+" input[type='radio']:first").prop("checked", true);
      //  console.log($('#'+this_id+" input[type='radio']").length);

        $(".prod-img > img").attr("src", image_src_element.attr("src"));
        $(".prod-name > .prod-title").html(title_element.text());
        $(".footer-cart-actions").html(button_element.clone().addClass("sas-kit-footer-cta").attr("href", "javascript:void(0)"));
        $(".sticky-footer-price").html(price_element.html());
      }

     /*$(".sas-purchase-option .one-time").click(function(e){
       console.log('trigger-2-'+$(this).attr("id"));
         $('#'+$(this).attr("id")+" input[type='radio']").prop("checked", true);
   });*/

  $(document).ready(function() {
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
              let scrollTop = $(window).scrollTop();
              let $stickyFooter = $(".sticky-sas");
                if (scrollTop > 1500 && !$('.sas-kit-event .sas-kit-cta').isInViewport()) {
                    create_sticky_footer(
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-image > img"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-title"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-price"),
                        $(".sas-page-kits-wrapper .sas-page-kit.active.selected").find(".sas-kit-cta")
                    );
                    $stickyFooter.show();
                } else {
                    $stickyFooter.hide();
                }
                ticking = false;
            });
            ticking = true;
        }
    }
    $(window).on('load resize scroll', onScroll);
});

  document.addEventListener("DOMContentLoaded", function () {
    if ( window.location.pathname === "/pages/sas-spl-credit-jfr" || window.location.pathname === "/pages/sas-spl-tv-credit-jfr" || window.location.pathname === "/pages/sas-spl-credit" || window.location.pathname === "/pages/sas-spl-tv-credit-cb" || window.location.pathname === "/pages/sas-spl-tv-credit" || window.location.pathname === "/pages/sas-spl-creditpdp") {
      var wrapper = document.querySelector(".sas-page-kits-wrapper");
      if (wrapper) {
        wrapper.classList.add("sas-credit-page");
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
